import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ApolloProvider } from '@apollo/react-hooks';
import { useGraphQLClient } from '../../graphql-client';
import SocialAuthCallbackBase from '../../SocialAuthCallback';
import { useConfig } from '../../context';
import { socialAuthPath } from '../../SocialAuthCallback/utils';
import { BootstrapGate } from '@shared/ui';

const SocialAuthCallback: React.FC = () => {
	const client = useGraphQLClient();
	const {
		global: { socialAuthCallbackUrl }
	} = useConfig();

	const basename = socialAuthCallbackUrl ? `${new URL(socialAuthCallbackUrl).pathname}` : socialAuthPath;

	return (
		<BootstrapGate>
			<BrowserRouter basename={basename}>
				<ApolloProvider client={client}>
					<SocialAuthCallbackBase socialAuthCallbackUrl={socialAuthCallbackUrl} />
				</ApolloProvider>
			</BrowserRouter>
		</BootstrapGate>
	);
};

export default SocialAuthCallback;
